export interface ConnectFlowSurveyFormState {
    name: string | null;
    textToAudio: string | null;
    audioFilePath: string | null;
    questions: ConnectFlowSurveyQuestionFormState[];
    isActive: boolean;
    finalTextToAudio: string | null;
    finalAudioFilePath: string | null;
}

export interface ConnectFlowSurveyQuestionFormState {
    id?: number;
    _key: string;
    label: string | null;
    rangeAnswer: string | null;
    textToAudio: string | null;
    audioFile: File | null;
    audioFilePath: string | null;
}
